export default __webpack_public_path__ + "static/media/tick.ce1e7175.svg";